module.exports = __webpack_public_path__ + "img/icon1.d961bb88.png";